import { connect } from 'react-redux';

import { notificationActions } from '../actions/notification';
import NotificationsList from '../components/NotificationsList';

const { notificationRemoveById } = notificationActions;

const mapStateToProps = (state: any) => {
  return {
    currentNotifications: state.notifications.currentNotifications,
    ratingNotificaions: state.notifications.ratingNotificaions,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    notificationRemoveById: (payload: any) =>
      dispatch(notificationRemoveById(payload)),
    dispatch: (func: () => void) => dispatch(func),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsList as any);
